import {customRoutes} from '../customRoutes';
import {oldAppReroutes} from '../bf_redirects';
import {Customization} from '@eduvision/toolkit';

export const routes: Customization['routes'] = {
  customRoutes: [...customRoutes,...oldAppReroutes]
};
